// extracted by mini-css-extract-plugin
export default {"flowImage":"FlowImage_flowImage__MN9pm"};